import React from 'react';
import PropTypes from "prop-types";

/**
 * Note that this component needs to support two types of error array, as the
 * errors might have originated from laravel or formik.
 *
 * Formik errors will be in the format:
 * {
 *     'myValidatedValue': 'error message'
 * }
 *
 * Laravel errors will be in the format:
 * {
 *     'visitors.0.myValidatedValue': ['possibly', 'multiple', 'error', 'messages']
 * }
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const FormErrorList = (props) => {
    const displayedErrors = new Set();

   const renderErrors = (errors) => {
        return Object.keys(errors)
            .map(key => {
                const error = errors[key];

                if (!(error instanceof Array)) {
                    // There is one error message
                    if (!displayedErrors.has(error)) {
                        displayedErrors.add(error);
                        return <li key={`${key}-${error}`}>{error}</li>;
                    }
                } else {
                    // There is an array of error messages for this value, just recursively pass into the same component
                    return renderErrors(error);
                }

                return null;
            });
   }

   return (
       <>
           {renderErrors(props.errors)}
       </>
   )
}


FormErrorList.propTypes = {
    errors: PropTypes.objectOf(
        PropTypes.oneOfType([
            PropTypes.string, // Formik-style single error message
            PropTypes.arrayOf(PropTypes.string), // Laravel-style multiple error messages
        ])
    ).isRequired,
};

FormErrorList.defaultProps = {
    errors: {},
};

export default FormErrorList;
